"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import Sal from "sal.js";
import ToolsBanner from "./ToolsBanner";
import BenefitsBanner from "./BenefitsBanner";
import PricingBanner from "./PricingBanner";

/**
 * Componente Home que muestra el slider de bienvenida.
 * Utiliza sal.js para animaciones y rota los mensajes destacados cada 2 segundos.
 *
 * @returns {JSX.Element} - Renderizado del slider de inicio.
 */
const Home = () => {
  // Estado que determina el índice del mensaje visible en el slider
  const [visibleIndex, setVisibleIndex] = useState(0);

  useEffect(() => {
    // Inicializa las animaciones con sal.js
    Sal();

    // Intervalo para cambiar el mensaje visible cada 2000ms (2 segundos)
    const intervalId = setInterval(() => {
      setVisibleIndex((prevIndex) => (prevIndex + 1) % 3);
    }, 2000);

    // Limpieza del intervalo cuando el componente se desmonte
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <div
        className="slider-area slider-style-1 variation-default slider-bg-image bg-banner1 slider-bg-shape"
        data-black-overlay="1"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="inner text-center mt--60 mb--20">
                <h1 className="title display-one">
                  Crea tu clase completa en
                  <br />{" "}
                  <span className="header-caption">
                    <span className="cd-headline rotate-1">
                      <span className="cd-words-wrapper">
                        <b
                          className={
                            visibleIndex === 0
                              ? "is-visible theme-gradient"
                              : "is-hidden theme-gradient"
                          }
                        >
                          minutos
                        </b>
                        <b
                          className={
                            visibleIndex === 1
                              ? "is-visible theme-gradient"
                              : "is-hidden theme-gradient"
                          }
                        >
                          segundos
                        </b>
                        <b
                          className={
                            visibleIndex === 2
                              ? "is-visible theme-gradient"
                              : "is-hidden theme-gradient"
                          }
                        >
                          TutorIA+
                        </b>
                      </span>
                    </span>
                  </span>
                </h1>

                <p className="description">
                  Plan de lección, evaluación y presentación listas en un solo
                  flujo para que ahorres tiempo y te enfoques en enseñar.
                </p>

                <Link className="btn-default" href="/registrarse">
                  Crear mi clase gratis
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rainbow-collobration-area rainbow-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="collabration-image-section text-center">
                <video
                  controls
                  controlsList="nodownload"
                  preload="metadata"
                  poster="/images/home/app-poster.webp"
                  playsInline
                  width={968}
                  height={778}
                >
                  <source src="/images/home/app.webm" type="video/webm" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="aiwave-service-area rainbow-section-gap">
        <div className="container">
          <div className="row row--15 service-wrapper">
            <BenefitsBanner />
          </div>
        </div>
      </div>

      <div className="rainbow-collobration-area mb--60">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="collabration-image-section">
                <video
                  controls
                  controlsList="nodownload"
                  preload="none"
                  poster="/images/home/how-to-use-poster.webp"
                  playsInline
                  width={1305}
                  height={652}
                >
                  <source
                    src="/images/home/how-to-use.webm"
                    type="video/webm"
                  />
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rainbow-service-area rainbow-section-gap">
        <div className="container">
          <ToolsBanner />
        </div>
      </div>

      <div className="aiwave-pricing-area wrapper rainbow-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center"
                data-sal="slide-up"
                data-sal-duration="400"
                data-sal-delay="150"
              >
                <h4 className="subtitle">
                  <span className="theme-gradient">Planes para todos</span>
                </h4>
                <h2 className="title w-600 mb--40">
                  Comienza gratis o pasa a un plan Ilimitado
                </h2>
              </div>
            </div>
          </div>

          <PricingBanner parentClass="col-xl-4 col-lg-6 col-md-6 col-12 mt--20" />
        </div>
      </div>

      <div className="rainbow-collobration-area rainbow-section-gap mb--40">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center"
                data-sal="slide-up"
                data-sal-duration="700"
                data-sal-delay="100"
              >
                <h4 className="subtitle ">
                  <span className="theme-gradient">
                    ¿Listo para ahorrar horas de preparación?
                  </span>
                </h4>
                <h2 className="title mb--20">
                  Crea tu próxima clase con plan de lección, evaluación y
                  presentación en un solo lugar, lista en minutos.
                </h2>
                <Link
                  className="btn-default btn-large color-blacked"
                  href="/registrarse"
                >
                  Crear mi clase{" "}
                  <i className="fa-sharp fa-solid fa-arrow-right ps-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
